export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
};

export type AdditionalServiceNode = Regular_Id_Node & {
  __typename?: 'AdditionalServiceNode';
  dealSet: DealNodeConnection;
  hasVat: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  isPriceOverrideable: Scalars['Boolean'];
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  proposalSet: ProposalNodeConnection;
  readableName: Scalars['String'];
  type: DealsAdditionalServiceTypeChoices;
};


export type AdditionalServiceNodeDealSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type AdditionalServiceNodeProposalSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AdditionalServiceNodeConnection = {
  __typename?: 'AdditionalServiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdditionalServiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AdditionalServiceNode` and its cursor. */
export type AdditionalServiceNodeEdge = {
  __typename?: 'AdditionalServiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AdditionalServiceNode>;
};

export type AuthUserNode = Regular_Id_Node & {
  __typename?: 'AuthUserNode';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isReadOnly: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  userPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  username: Scalars['String'];
};

export type AuthUserNodeConnection = {
  __typename?: 'AuthUserNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AuthUserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AuthUserNode` and its cursor. */
export type AuthUserNodeEdge = {
  __typename?: 'AuthUserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AuthUserNode>;
};

export type BankNode = Regular_Id_Node & {
  __typename?: 'BankNode';
  carSet: CarNodeConnection;
  code: Scalars['String'];
  customerSet: CustomerNodeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type BankNodeCarSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BankNodeCustomerSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type BankNodeConnection = {
  __typename?: 'BankNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BankNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BankNode` and its cursor. */
export type BankNodeEdge = {
  __typename?: 'BankNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<BankNode>;
};

export type BrandNode = Regular_Id_Node & {
  __typename?: 'BrandNode';
  carmodelSet?: Maybe<CarModelNodeConnection>;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type BrandNodeCarmodelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nameIcontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type BrandNodeConnection = {
  __typename?: 'BrandNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BrandNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BrandNode` and its cursor. */
export type BrandNodeEdge = {
  __typename?: 'BrandNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<BrandNode>;
};

/** An enumeration. */
export enum CarCarPositionLocationChoices {
  /** רכב אצל עובד */
  Emp = 'EMP',
  /** רכב אצל עובד */
  Employ = 'EMPLOY',
  /** מוסכים שונים */
  Garahg = 'GARAHG',
  /** מאיר */
  Meir = 'MEIR',
  /** מגרש שמשון פ"ת */
  Office = 'OFFICE',
  /** וואן ליס - סניף ראשי */
  Onelease = 'ONELEASE',
  /** השכרה */
  OnRent = 'ON_RENT',
  /** רכב נמכר */
  Sold = 'SOLD',
  /** רכב נמכר בתשלומים */
  SoldInPayments = 'SOLD_IN_PAYMENTS',
  /** טוטאל לוסט */
  Totalus = 'TOTALUS',
  /** לא ידוע */
  Unknown = 'UNKNOWN',
  /** יוסי איה */
  YosiAia = 'YOSI_AIA'
}

/** An enumeration. */
export enum CarCarPositionPreviousLocationChoices {
  /** רכב אצל עובד */
  Emp = 'EMP',
  /** רכב אצל עובד */
  Employ = 'EMPLOY',
  /** מוסכים שונים */
  Garahg = 'GARAHG',
  /** מאיר */
  Meir = 'MEIR',
  /** מגרש שמשון פ"ת */
  Office = 'OFFICE',
  /** וואן ליס - סניף ראשי */
  Onelease = 'ONELEASE',
  /** השכרה */
  OnRent = 'ON_RENT',
  /** רכב נמכר */
  Sold = 'SOLD',
  /** רכב נמכר בתשלומים */
  SoldInPayments = 'SOLD_IN_PAYMENTS',
  /** טוטאל לוסט */
  Totalus = 'TOTALUS',
  /** לא ידוע */
  Unknown = 'UNKNOWN',
  /** יוסי איה */
  YosiAia = 'YOSI_AIA'
}

/** An enumeration. */
export enum CarCarServiceProviderChoices {
  /** הסכם יבואן */
  ImportAgent = 'IMPORT_AGENT',
  /** כיל */
  Kil = 'KIL',
  /** אחזקה עצמית */
  SelfService = 'SELF_SERVICE'
}

/** An enumeration. */
export enum CarCarStatusChoices {
  /** עם נזקים */
  Damages = 'DAMAGES',
  /** למכירה */
  ForSale = 'FOR_SALE',
  /** בליסינג */
  InLeasing = 'IN_LEASING',
  /** מימוש אופציה */
  OptionFulfilled = 'OPTION_FULFILLED',
  /** מימוש אופציה ללא העברה */
  OptionWithoutTransfer = 'OPTION_WITHOUT_TRANSFER',
  /** השכרה */
  Rent = 'RENT',
  /** שמור ללקוח */
  SavedForClient = 'SAVED_FOR_CLIENT',
  /** נמכר */
  Sold = 'SOLD',
  /** נמכר ללא העברה */
  SoldWithoutTransfer = 'SOLD_WITHOUT_TRANSFER',
  /** נגנב */
  Stolen = 'STOLEN',
  /** טוטלוסט */
  TotalLost = 'TOTAL_LOST',
  /** ממתין למכירה */
  WaitingForSale = 'WAITING_FOR_SALE'
}

/** An enumeration. */
export enum CarCarSubModelFuelTypeChoices {
  /** Diesel */
  Diesel = 'DIESEL',
  /** Gasoline */
  Gasoline = 'GASOLINE'
}

/** An enumeration. */
export enum CarCarSubModelTransmissionTypeChoices {
  /** Automatic */
  Automatic = 'AUTOMATIC',
  /** Manual */
  Manual = 'MANUAL'
}

export type CarModelNode = Regular_Id_Node & {
  __typename?: 'CarModelNode';
  brand: BrandNode;
  carsubmodelSet?: Maybe<CarSubModelNodeConnection>;
  /** The ID of the object */
  id: Scalars['ID'];
  localName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};


export type CarModelNodeCarsubmodelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nameIcontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CarModelNodeConnection = {
  __typename?: 'CarModelNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CarModelNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CarModelNode` and its cursor. */
export type CarModelNodeEdge = {
  __typename?: 'CarModelNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CarModelNode>;
};

export type CarNode = Regular_Id_Node & {
  __typename?: 'CarNode';
  activeDeal?: Maybe<DealNode>;
  bank?: Maybe<BankNode>;
  carSubModel: CarSubModelNode;
  color?: Maybe<Scalars['String']>;
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  creationYear: Scalars['Int'];
  customer?: Maybe<CustomerNode>;
  damages?: Maybe<Scalars['String']>;
  deals: DealNodeConnection;
  driver?: Maybe<DriverNode>;
  frameSerialNumber?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  importerDiscount?: Maybe<Scalars['Float']>;
  insuranceCompanyName?: Maybe<Scalars['String']>;
  insuranceExpDate?: Maybe<Scalars['Date']>;
  insuranceReminderSentCount: Scalars['Int'];
  insuranceReminderSentDate?: Maybe<Scalars['Date']>;
  invoiceitemSet: InvoiceItemNodeConnection;
  km?: Maybe<Scalars['Int']>;
  lastCheckInTime?: Maybe<Scalars['DateTime']>;
  licenceExpDate?: Maybe<Scalars['Date']>;
  notes?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  parkingLocation?: Maybe<Scalars['String']>;
  positions: CarPositionNodeConnection;
  purchaseTime?: Maybe<Scalars['DateTime']>;
  rentalTime?: Maybe<Scalars['DateTime']>;
  reportSet: ReportNodeConnection;
  salePrice?: Maybe<Scalars['Float']>;
  saleTime?: Maybe<Scalars['DateTime']>;
  serviceProvider?: Maybe<CarCarServiceProviderChoices>;
  status: CarCarStatusChoices;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
  vehicleCode?: Maybe<Scalars['String']>;
};


export type CarNodeDealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CarNodeInvoiceitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CarNodePositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CarNodeReportSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CarNodeConnection = {
  __typename?: 'CarNodeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CarNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CarNode` and its cursor. */
export type CarNodeEdge = {
  __typename?: 'CarNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CarNode>;
};

export type CarPositionNode = Regular_Id_Node & {
  __typename?: 'CarPositionNode';
  car: CarNode;
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  customer?: Maybe<CustomerNode>;
  deal?: Maybe<DealNode>;
  driver?: Maybe<DriverNode>;
  endTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  kmIn?: Maybe<Scalars['Int']>;
  kmOut?: Maybe<Scalars['Int']>;
  location?: Maybe<CarCarPositionLocationChoices>;
  previousLocation?: Maybe<CarCarPositionPreviousLocationChoices>;
  reportSet: ReportNodeConnection;
  startTime?: Maybe<Scalars['DateTime']>;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
};


export type CarPositionNodeReportSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CarPositionNodeConnection = {
  __typename?: 'CarPositionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CarPositionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CarPositionNode` and its cursor. */
export type CarPositionNodeEdge = {
  __typename?: 'CarPositionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CarPositionNode>;
};

export type CarSubModelNode = Regular_Id_Node & {
  __typename?: 'CarSubModelNode';
  carModel: CarModelNode;
  carSet: CarNodeConnection;
  dealSet: DealNodeConnection;
  doorNumber?: Maybe<Scalars['Int']>;
  engineCapacity?: Maybe<Scalars['Int']>;
  fuelType?: Maybe<CarCarSubModelFuelTypeChoices>;
  /** The ID of the object */
  id: Scalars['ID'];
  localName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  priceListNumber?: Maybe<Scalars['String']>;
  proposalSet: ProposalNodeConnection;
  transmissionType?: Maybe<CarCarSubModelTransmissionTypeChoices>;
};


export type CarSubModelNodeCarSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CarSubModelNodeDealSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CarSubModelNodeProposalSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CarSubModelNodeConnection = {
  __typename?: 'CarSubModelNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CarSubModelNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CarSubModelNode` and its cursor. */
export type CarSubModelNodeEdge = {
  __typename?: 'CarSubModelNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CarSubModelNode>;
};

export type ChangeListItemNode = {
  __typename?: 'ChangeListItemNode';
  changedAt?: Maybe<Scalars['DateTime']>;
  changedBy?: Maybe<AuthUserNode>;
  field?: Maybe<Scalars['ID']>;
  new?: Maybe<Scalars['ID']>;
  old?: Maybe<Scalars['ID']>;
};

export type ChargeNode = Regular_Id_Node & {
  __typename?: 'ChargeNode';
  amount: Scalars['Float'];
  baseAmount: Scalars['Float'];
  baseIndex: Scalars['Float'];
  chargeTime: Scalars['DateTime'];
  chargeType: PaymentChargeChargeTypeChoices;
  chargedIndex: Scalars['Float'];
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  currency: PaymentChargeCurrencyChoices;
  deal?: Maybe<DealNode>;
  description?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoice?: Maybe<InvoiceNode>;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
};

export type ChargeNodeConnection = {
  __typename?: 'ChargeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChargeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ChargeNode` and its cursor. */
export type ChargeNodeEdge = {
  __typename?: 'ChargeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ChargeNode>;
};

/** An enumeration. */
export enum ComplaintsReportSourceChoices {
  /** City Parking Ticker */
  CityParking = 'CITY_PARKING',
  /** Other */
  Other = 'OTHER',
  /** Police Ticket */
  Police = 'POLICE'
}

export type CustomerNode = Regular_Id_Node & {
  __typename?: 'CustomerNode';
  accountManager?: Maybe<MeNode>;
  additionalAddress?: Maybe<Scalars['String']>;
  additionalFax?: Maybe<Scalars['String']>;
  additionalPhone?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  bank?: Maybe<BankNode>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  branchNumber?: Maybe<Scalars['String']>;
  carpositionSet: CarPositionNodeConnection;
  cars?: Maybe<CarNodeConnection>;
  city?: Maybe<Scalars['String']>;
  companyNumber?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  deals: DealNodeConnection;
  driverSet: DriverNodeConnection;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  idAsString?: Maybe<Scalars['String']>;
  invoiceSet: InvoiceNodeConnection;
  isActive: Scalars['Boolean'];
  isIntegratedToPriority: Scalars['Boolean'];
  name: Scalars['String'];
  oldNumber?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  proposals: ProposalNodeConnection;
  reportSet: ReportNodeConnection;
  shouldUnionInvoices: Scalars['Boolean'];
  standingOrderLimit?: Maybe<Scalars['Float']>;
  title?: Maybe<CustomersCustomerTitleChoices>;
  type: CustomersCustomerTypeChoices;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
  zip?: Maybe<Scalars['Int']>;
};


export type CustomerNodeCarpositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CustomerNodeCarsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CustomerNodeDealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CustomerNodeDriverSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CustomerNodeInvoiceSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CustomerNodeProposalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CustomerNodeReportSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CustomerNodeConnection = {
  __typename?: 'CustomerNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CustomerNode` and its cursor. */
export type CustomerNodeEdge = {
  __typename?: 'CustomerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerNode>;
};

/** An enumeration. */
export enum CustomersCustomerTitleChoices {
  /** MR */
  Mr = 'MR',
  /** MRS */
  Mrs = 'MRS'
}

/** An enumeration. */
export enum CustomersCustomerTypeChoices {
  /** Business */
  Business = 'BUSINESS',
  /** Private */
  Private = 'PRIVATE'
}

export type DealDeprecatedHistoryNode = Regular_Id_Node & {
  __typename?: 'DealDeprecatedHistoryNode';
  createUser?: Maybe<MeNode>;
  deal: DealNode;
  fieldName?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
};

export type DealDeprecatedHistoryNodeConnection = {
  __typename?: 'DealDeprecatedHistoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DealDeprecatedHistoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DealDeprecatedHistoryNode` and its cursor. */
export type DealDeprecatedHistoryNodeEdge = {
  __typename?: 'DealDeprecatedHistoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DealDeprecatedHistoryNode>;
};

export type DealNode = Regular_Id_Node & {
  __typename?: 'DealNode';
  additionalServices: AdditionalServiceNodeConnection;
  agent?: Maybe<MeNode>;
  baseIndex?: Maybe<Scalars['Float']>;
  car?: Maybe<CarNode>;
  carPrice?: Maybe<Scalars['Float']>;
  carPriceLeftToPayIndexed?: Maybe<Scalars['Float']>;
  carSubModel?: Maybe<CarSubModelNode>;
  carpositionSet: CarPositionNodeConnection;
  changelist?: Maybe<Array<Maybe<ChangeListItemNode>>>;
  charges: ChargeNodeConnection;
  comprehensiveInsurancePrice?: Maybe<Scalars['Float']>;
  comprehensiveInsuranceYoungPrice?: Maybe<Scalars['Float']>;
  compulsoryInsurancePrice?: Maybe<Scalars['Float']>;
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  currency: DealsDealCurrencyChoices;
  customer?: Maybe<CustomerNode>;
  dealTypeString?: Maybe<Scalars['String']>;
  dealdeprecatedhistorySet: DealDeprecatedHistoryNodeConnection;
  deposit?: Maybe<Scalars['Float']>;
  endDate: Scalars['Date'];
  expirationReminderSentCount: Scalars['Int'];
  expirationReminderSentDate?: Maybe<Scalars['Date']>;
  freeKmPerYear?: Maybe<Scalars['Int']>;
  fullMonthlyPrice?: Maybe<Scalars['Float']>;
  /** The ID of the object */
  id: Scalars['ID'];
  idAsString?: Maybe<Scalars['String']>;
  installations: InstallationNodeConnection;
  invoiceitemSet: InvoiceItemNodeConnection;
  isOperational: Scalars['Boolean'];
  lastChargeDate?: Maybe<Scalars['Date']>;
  leaseDuration: Scalars['Int'];
  licenceAndInsurancePricePerMonth?: Maybe<Scalars['Float']>;
  licencePrice?: Maybe<Scalars['Float']>;
  modelYear?: Maybe<Scalars['Int']>;
  monthLeftToPay?: Maybe<Scalars['Int']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
  monthlyVatPriceIndexed?: Maybe<Scalars['Float']>;
  npv?: Maybe<Scalars['Float']>;
  nextChargeDate?: Maybe<Scalars['Date']>;
  notes?: Maybe<Scalars['String']>;
  numberOfCharges?: Maybe<Scalars['Int']>;
  participationFee?: Maybe<Scalars['Float']>;
  proposal?: Maybe<ProposalNode>;
  proposalNumberRef?: Maybe<Scalars['String']>;
  reportSet: ReportNodeConnection;
  residualPrice?: Maybe<Scalars['Float']>;
  securityDeposit?: Maybe<Scalars['Float']>;
  servicePrice?: Maybe<Scalars['Float']>;
  signDate?: Maybe<Scalars['Date']>;
  startDate: Scalars['Date'];
  status?: Maybe<DealsDealStatusChoices>;
  totalPrice?: Maybe<Scalars['Float']>;
  trackingInstallationRate?: Maybe<Scalars['Float']>;
  trackingMonthlyRate?: Maybe<Scalars['Float']>;
  treatmentSet: TreatmentNodeConnection;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
};


export type DealNodeAdditionalServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DealNodeCarpositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DealNodeChargesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DealNodeDealdeprecatedhistorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DealNodeInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DealNodeInvoiceitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DealNodeReportSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DealNodeTreatmentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DealNodeConnection = {
  __typename?: 'DealNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DealNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DealNode` and its cursor. */
export type DealNodeEdge = {
  __typename?: 'DealNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DealNode>;
};

/** An enumeration. */
export enum DealsAdditionalServiceTypeChoices {
  /** Accessory */
  Accessory = 'ACCESSORY',
  /** Service */
  Service = 'SERVICE'
}

/** An enumeration. */
export enum DealsDealCurrencyChoices {
  /** ILS */
  Ils = 'ILS'
}

/** An enumeration. */
export enum DealsDealStatusChoices {
  /** מבוטלת */
  Canceled = 'CANCELED',
  /** סגורה */
  Closed = 'CLOSED',
  /** בהקמה */
  InCreation = 'IN_CREATION',
  /** פתוחה */
  Open = 'OPEN'
}

/** An enumeration. */
export enum DealsInstallationInstallationTypeChoices {
  /** Importer */
  Importer = 'IMPORTER',
  /** Leasing company */
  LeasingCompany = 'LEASING_COMPANY'
}

/** An enumeration. */
export enum DealsProposalCurrencyChoices {
  /** ILS */
  Ils = 'ILS'
}

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename?: 'DjangoDebug';
  /** Executed SQL queries for this API query. */
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  __typename?: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float'];
  /** Postgres connection encoding if available. */
  encoding?: Maybe<Scalars['String']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean'];
  /** Postgres isolation level if available. */
  isoLevel?: Maybe<Scalars['String']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String'];
  /** The actual SQL sent to this database. */
  sql?: Maybe<Scalars['String']>;
  /** Start time of this database query. */
  startTime: Scalars['Float'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float'];
  /** Postgres transaction ID if available. */
  transId?: Maybe<Scalars['String']>;
  /** Postgres transaction status if available. */
  transStatus?: Maybe<Scalars['String']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String'];
};

export type DriverNode = Regular_Id_Node & {
  __typename?: 'DriverNode';
  additionalAddress?: Maybe<Scalars['String']>;
  additionalFax?: Maybe<Scalars['String']>;
  additionalPhone?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['Date']>;
  carSet: CarNodeConnection;
  carpositionSet: CarPositionNodeConnection;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customer: CustomerNode;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  idNumber?: Maybe<Scalars['String']>;
  invoiceitemSet: InvoiceItemNodeConnection;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  reportSet: ReportNodeConnection;
  zip?: Maybe<Scalars['Int']>;
};


export type DriverNodeCarSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DriverNodeCarpositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DriverNodeInvoiceitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DriverNodeReportSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DriverNodeConnection = {
  __typename?: 'DriverNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DriverNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DriverNode` and its cursor. */
export type DriverNodeEdge = {
  __typename?: 'DriverNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DriverNode>;
};

export type GeneralSettingsObjectType = {
  __typename?: 'GeneralSettingsObjectType';
  index?: Maybe<Scalars['Float']>;
};

export type InstallationNode = Regular_Id_Node & {
  __typename?: 'InstallationNode';
  dealSet: DealNodeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  installationType: DealsInstallationInstallationTypeChoices;
  isCustomerPaid: Scalars['Boolean'];
  name: Scalars['String'];
  priceWithoutVat: Scalars['Decimal'];
  proposalSet: ProposalNodeConnection;
};


export type InstallationNodeDealSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type InstallationNodeProposalSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type InstallationNodeConnection = {
  __typename?: 'InstallationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InstallationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InstallationNode` and its cursor. */
export type InstallationNodeEdge = {
  __typename?: 'InstallationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InstallationNode>;
};

export type InvoiceItemNode = Regular_Id_Node & {
  __typename?: 'InvoiceItemNode';
  baseIndex: Scalars['Float'];
  baseIndexPrice?: Maybe<Scalars['Float']>;
  baseLicenceAndInsurancePrice?: Maybe<Scalars['Float']>;
  baseMaintenancePrice?: Maybe<Scalars['Float']>;
  basePrice: Scalars['Float'];
  baseRentalPrice?: Maybe<Scalars['Float']>;
  car?: Maybe<CarNode>;
  carNumber?: Maybe<Scalars['String']>;
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  deal?: Maybe<DealNode>;
  driver?: Maybe<DriverNode>;
  driverName?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoice: InvoiceNode;
  noVatPrice?: Maybe<Scalars['Float']>;
  paymentNumber?: Maybe<Scalars['Int']>;
  totalPrice: Scalars['Float'];
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
  vatIndexPriceDiff?: Maybe<Scalars['Float']>;
  vatPrice: Scalars['Float'];
};

export type InvoiceItemNodeConnection = {
  __typename?: 'InvoiceItemNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InvoiceItemNode` and its cursor. */
export type InvoiceItemNodeEdge = {
  __typename?: 'InvoiceItemNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InvoiceItemNode>;
};

export type InvoiceNode = Regular_Id_Node & {
  __typename?: 'InvoiceNode';
  additionalAddress?: Maybe<Scalars['String']>;
  additionalFax?: Maybe<Scalars['String']>;
  additionalPhone?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  baseIndexPrice?: Maybe<Scalars['Float']>;
  baseLicenceAndInsurancePrice?: Maybe<Scalars['Float']>;
  baseMaintenancePrice?: Maybe<Scalars['Float']>;
  baseRentalPrice?: Maybe<Scalars['Float']>;
  chargeDate?: Maybe<Scalars['Date']>;
  chargedIndex: Scalars['Float'];
  charges: ChargeNodeConnection;
  city?: Maybe<Scalars['String']>;
  companyNumber?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  currency: PaymentInvoiceCurrencyChoices;
  customer?: Maybe<CustomerNode>;
  customerName?: Maybe<Scalars['String']>;
  dealIds?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  fax?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  idAsString?: Maybe<Scalars['String']>;
  isIntegratedToPriority: Scalars['Boolean'];
  isPrinted: Scalars['Boolean'];
  isSent: Scalars['Boolean'];
  items: InvoiceItemNodeConnection;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  totalIndexPriceDiff?: Maybe<Scalars['Float']>;
  totalPrice: Scalars['Float'];
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
  vatIndexPriceDiff?: Maybe<Scalars['Float']>;
  vatPrice: Scalars['Float'];
  vatRate: Scalars['Float'];
  zip?: Maybe<Scalars['Int']>;
};


export type InvoiceNodeChargesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type InvoiceNodeItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type InvoiceNodeConnection = {
  __typename?: 'InvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InvoiceNode` and its cursor. */
export type InvoiceNodeEdge = {
  __typename?: 'InvoiceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InvoiceNode>;
};

export type MeNode = Regular_Id_Node & {
  __typename?: 'MeNode';
  carCreated: CarNodeConnection;
  carUpdated: CarNodeConnection;
  carpositionCreated: CarPositionNodeConnection;
  carpositionUpdated: CarPositionNodeConnection;
  chargeCreated: ChargeNodeConnection;
  chargeUpdated: ChargeNodeConnection;
  customerCreated: CustomerNodeConnection;
  customerSet: CustomerNodeConnection;
  customerUpdated: CustomerNodeConnection;
  dateJoined?: Maybe<Scalars['DateTime']>;
  dealCreated: DealNodeConnection;
  dealUpdated: DealNodeConnection;
  dealdeprecatedhistoryCreated: DealDeprecatedHistoryNodeConnection;
  dealdeprecatedhistoryUpdated: DealDeprecatedHistoryNodeConnection;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  invoiceCreated: InvoiceNodeConnection;
  invoiceUpdated: InvoiceNodeConnection;
  invoiceitemCreated: InvoiceItemNodeConnection;
  invoiceitemUpdated: InvoiceItemNodeConnection;
  isActive: Scalars['Boolean'];
  isReadOnly: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  /** מציין שלמשתמש זה יש את כל ההרשאות ללא הצורך המפורש בהענקתן. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  proposalCreated: ProposalNodeConnection;
  proposalSet: ProposalNodeConnection;
  proposalUpdated: ProposalNodeConnection;
  proposalsAgent: DealNodeConnection;
  reportCreated: ReportNodeConnection;
  reportUpdated: ReportNodeConnection;
  treatmentCreated: TreatmentNodeConnection;
  treatmentUpdated: TreatmentNodeConnection;
  userPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  username: Scalars['String'];
};


export type MeNodeCarCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeCarUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeCarpositionCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeCarpositionUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeChargeCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeChargeUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeCustomerCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeCustomerSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeCustomerUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeDealCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeDealUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeDealdeprecatedhistoryCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeDealdeprecatedhistoryUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeInvoiceCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeInvoiceUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeInvoiceitemCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeInvoiceitemUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeProposalCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeProposalSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeProposalUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeProposalsAgentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeReportCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeReportUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeTreatmentCreatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MeNodeTreatmentUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PaymentChargeChargeTypeChoices {
  /** In advance charge */
  InAdvance = 'IN_ADVANCE',
  /** Optional charge */
  Optional = 'OPTIONAL',
  /** Self Participation Fee */
  Sp = 'SP',
  /** Vehicle */
  Vehicle = 'VEHICLE'
}

/** An enumeration. */
export enum PaymentChargeCurrencyChoices {
  /** ILS */
  Ils = 'ILS'
}

/** An enumeration. */
export enum PaymentInvoiceCurrencyChoices {
  /** ILS */
  Ils = 'ILS'
}

export type ProposalNode = Regular_Id_Node & {
  __typename?: 'ProposalNode';
  additionalServices: AdditionalServiceNodeConnection;
  agent?: Maybe<MeNode>;
  baseIndex?: Maybe<Scalars['Float']>;
  carPrice?: Maybe<Scalars['Float']>;
  carSubModel?: Maybe<CarSubModelNode>;
  comprehensiveInsurancePrice?: Maybe<Scalars['Float']>;
  comprehensiveInsuranceYoungPrice?: Maybe<Scalars['Float']>;
  compulsoryInsurancePrice?: Maybe<Scalars['Float']>;
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  currency: DealsProposalCurrencyChoices;
  customer?: Maybe<CustomerNode>;
  dealTypeString?: Maybe<Scalars['String']>;
  deals: DealNodeConnection;
  deposit?: Maybe<Scalars['Float']>;
  freeKmPerYear?: Maybe<Scalars['Int']>;
  hasDeal?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  idAsString?: Maybe<Scalars['String']>;
  installations: InstallationNodeConnection;
  isLocked: Scalars['Boolean'];
  isOperational: Scalars['Boolean'];
  leaseDuration: Scalars['Int'];
  licencePrice?: Maybe<Scalars['Float']>;
  modelYear?: Maybe<Scalars['Int']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  participationFee?: Maybe<Scalars['Float']>;
  residualPrice?: Maybe<Scalars['Float']>;
  securityDeposit?: Maybe<Scalars['Float']>;
  servicePrice?: Maybe<Scalars['Float']>;
  taxLevel?: Maybe<Scalars['Int']>;
  totalPrice?: Maybe<Scalars['Float']>;
  trackingInstallationRate?: Maybe<Scalars['Float']>;
  trackingMonthlyRate?: Maybe<Scalars['Float']>;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};


export type ProposalNodeAdditionalServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProposalNodeDealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProposalNodeInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProposalNodeConnection = {
  __typename?: 'ProposalNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProposalNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProposalNode` and its cursor. */
export type ProposalNodeEdge = {
  __typename?: 'ProposalNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProposalNode>;
};

export type Query = {
  __typename?: 'Query';
  _debug?: Maybe<DjangoDebug>;
  additionalService?: Maybe<AdditionalServiceNode>;
  allAdditionalServices?: Maybe<AdditionalServiceNodeConnection>;
  allBanks?: Maybe<BankNodeConnection>;
  allBrands?: Maybe<BrandNodeConnection>;
  allCarModels?: Maybe<CarModelNodeConnection>;
  allCarSubModels?: Maybe<CarSubModelNodeConnection>;
  allCars?: Maybe<CarNodeConnection>;
  allCarsPositions?: Maybe<CarPositionNodeConnection>;
  allCharges?: Maybe<ChargeNodeConnection>;
  allCustomers?: Maybe<CustomerNodeConnection>;
  allDeals?: Maybe<DealNodeConnection>;
  allDeprecatedHistory?: Maybe<DealDeprecatedHistoryNodeConnection>;
  allDrivers?: Maybe<DriverNodeConnection>;
  allInstallations?: Maybe<InstallationNodeConnection>;
  allInvoices?: Maybe<InvoiceNodeConnection>;
  allProposals?: Maybe<ProposalNodeConnection>;
  allReports?: Maybe<ReportNodeConnection>;
  allTreatments?: Maybe<TreatmentNodeConnection>;
  allUsers?: Maybe<AuthUserNodeConnection>;
  bank?: Maybe<BankNode>;
  brand?: Maybe<BrandNode>;
  car?: Maybe<CarNode>;
  carModel?: Maybe<CarModelNode>;
  carPosition?: Maybe<CarPositionNode>;
  carSubModel?: Maybe<CarSubModelNode>;
  changeListItem?: Maybe<ChangeListItemNode>;
  charge?: Maybe<ChargeNode>;
  customer?: Maybe<CustomerNode>;
  deal?: Maybe<DealNode>;
  deprecatedHistory?: Maybe<DealDeprecatedHistoryNode>;
  driver?: Maybe<DriverNode>;
  generalSettings?: Maybe<GeneralSettingsObjectType>;
  installation?: Maybe<InstallationNode>;
  invoice?: Maybe<InvoiceNode>;
  invoiceItem?: Maybe<InvoiceItemNode>;
  me?: Maybe<MeNode>;
  proposal?: Maybe<ProposalNode>;
  report?: Maybe<ReportNode>;
  search?: Maybe<SearchConnection>;
  treatment?: Maybe<TreatmentNode>;
  user?: Maybe<AuthUserNode>;
};


export type QueryAdditionalServiceArgs = {
  id: Scalars['ID'];
};


export type QueryAllAdditionalServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllBanksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllBrandsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nameIcontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCarModelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nameIcontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCarSubModelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nameIcontains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCarsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['Float']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryAllCarsPositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  carNumber?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllChargesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  nameIncludes?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  oldNumber?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryAllDealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['Float']>;
  first?: InputMaybe<Scalars['Int']>;
  isOperational?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryAllDeprecatedHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllDriversArgs = {
  additionalAddress?: InputMaybe<Scalars['String']>;
  additionalFax?: InputMaybe<Scalars['String']>;
  additionalPhone?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  idNumber?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameIncludes?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['Int']>;
};


export type QueryAllInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['Float']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryAllProposalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['Float']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryAllReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['Float']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryAllTreatmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  nameContains?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBankArgs = {
  id: Scalars['ID'];
};


export type QueryBrandArgs = {
  id: Scalars['ID'];
};


export type QueryCarArgs = {
  id: Scalars['ID'];
};


export type QueryCarModelArgs = {
  id: Scalars['ID'];
};


export type QueryCarPositionArgs = {
  id: Scalars['ID'];
};


export type QueryCarSubModelArgs = {
  id: Scalars['ID'];
};


export type QueryChangeListItemArgs = {
  id: Scalars['ID'];
};


export type QueryChargeArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryDealArgs = {
  id: Scalars['ID'];
};


export type QueryDeprecatedHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryDriverArgs = {
  id: Scalars['ID'];
};


export type QueryInstallationArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceItemArgs = {
  id: Scalars['ID'];
};


export type QueryProposalArgs = {
  id: Scalars['ID'];
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  models?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};


export type QueryTreatmentArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type ReportNode = Regular_Id_Node & {
  __typename?: 'ReportNode';
  car?: Maybe<CarNode>;
  carNumber?: Maybe<Scalars['String']>;
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  crimeTime: Scalars['DateTime'];
  customer?: Maybe<CustomerNode>;
  deal?: Maybe<DealNode>;
  driver?: Maybe<DriverNode>;
  /** The ID of the object */
  id: Scalars['ID'];
  idAsString?: Maybe<Scalars['String']>;
  issueTime: Scalars['DateTime'];
  location?: Maybe<Scalars['String']>;
  originalPrintDate?: Maybe<Scalars['DateTime']>;
  position?: Maybe<CarPositionNode>;
  priceWithVat?: Maybe<Scalars['Float']>;
  priceWithoutVat?: Maybe<Scalars['Float']>;
  reportNumber: Scalars['String'];
  source: ComplaintsReportSourceChoices;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
};

export type ReportNodeConnection = {
  __typename?: 'ReportNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReportNode` and its cursor. */
export type ReportNodeEdge = {
  __typename?: 'ReportNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReportNode>;
};

export type SearchConnection = {
  __typename?: 'SearchConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Search` and its cursor. */
export type SearchEdge = {
  __typename?: 'SearchEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchObjectType>;
};

export type SearchObjectType = {
  __typename?: 'SearchObjectType';
  creationTime?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type TreatmentNode = Regular_Id_Node & {
  __typename?: 'TreatmentNode';
  createUser?: Maybe<MeNode>;
  creationTime?: Maybe<Scalars['DateTime']>;
  deal: DealNode;
  description?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  treatmentTime?: Maybe<Scalars['DateTime']>;
  updateTime?: Maybe<Scalars['DateTime']>;
  updateUser?: Maybe<MeNode>;
};

export type TreatmentNodeConnection = {
  __typename?: 'TreatmentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TreatmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TreatmentNode` and its cursor. */
export type TreatmentNodeEdge = {
  __typename?: 'TreatmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TreatmentNode>;
};

export type Regular_Id_Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};
